import Banner from "./components/Banner";
import Relive from "./components/Relive";
import Classic from "./components/Classic";
import Categories from "./components/Categories";
import Follow from "./components/Follow";
import HomeLocations from "./components/HomeLocations";
import YouTubeFollow from "./components/YouTubeFollow";


function Home() {
  return (
    <>
      <Banner />
      <Relive />
      <Classic />
      <Categories />     
      <HomeLocations />
      <YouTubeFollow />
    </>
  );
}

export default Home;